

import { Button } from '@/components/ui/button';

interface EmptyPostsStateProps {
  hasSearchQuery: boolean;
  onCreatePost: () => void;
}

export const EmptyPostsState: React.FC<EmptyPostsStateProps> = ({ 
  hasSearchQuery, 
  onCreatePost 
}) => {
  return (
    <div className="text-center py-12 border rounded-md bg-background">
      <h3 className="text-lg font-medium mb-2">No blog posts found</h3>
      {hasSearchQuery ? (
        <p className="text-neutral-600">
          No posts match your search query. Try a different search term.
        </p>
      ) : (
        <p className="text-neutral-600">
          You haven't created any blog posts yet. Get started by creating your first post.
        </p>
      )}
      {!hasSearchQuery && (
        <Button className="mt-4" onClick={onCreatePost}>
          Create Your First Post
        </Button>
      )}
    </div>
  );
};
